// extracted by mini-css-extract-plugin
export var actionIcon = "_ub-0";